var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Div, Row } from "react-vcomponents";
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { RedoAction } from "Server/Commands/RedoAction";
import { UndoAction } from "Server/Commands/UndoAction";
import { GetRedoAction, GetUndoAction } from "Store/firebase/userExtras/$userExtras/recentActions";
import { Link, Observer } from "vwebapp-framework";
import { colors } from "Utils/UI/GlobalStyles";
import { store } from "Store";
import { GetAuth } from "../../Store/firebase";
import { ChatPanel } from "./NavBar/ChatPanel";
import { GuidePanel } from "./NavBar/GuidePanel";
import { NotificationsUI } from "./NavBar/NotificationsUI";
import { ReputationPanel } from "./NavBar/ReputationPanel";
import { SearchPanel } from "./NavBar/SearchPanel";
import { StreamPanel } from "./NavBar/StreamPanel";
import { UserPanel } from "./NavBar/UserPanel";
import { IsAuthValid } from "mobx-firelink";
import { E } from "js-vextensions";
import { useCallback } from "react";
import { runInAction } from "mobx";
import { MeID } from "Store/firebase/users";
import { VoicePanel } from "./NavBar/VoicePanel";
import { rootPageDefaultChilds } from "Utils/URL/URLs";
// main
// ==========
const originSettings = { horizontal: "right", vertical: "top" };
const buttonStyle = { color: "white", textDecoration: "none" };
const avatarSize = 50;
const avatarStyles = {
    icon: { width: avatarSize, height: avatarSize },
    button: { marginRight: "1.5rem", width: avatarSize, height: avatarSize },
    wrapper: { marginTop: 45 - avatarSize },
};
let NavBar = class NavBar extends BaseComponent {
    render() {
        const topLeftOpenPanel = store.main.topLeftOpenPanel;
        const topRightOpenPanel = store.main.topRightOpenPanel;
        const auth = GetAuth();
        return (React.createElement("nav", { style: {
                position: "relative", zIndex: 11, padding: "0 10px", boxShadow: colors.navBarBoxShadow,
                //background: "#000 url('/Images/Tiling/TopMenu.png') repeat-x scroll",
                background: "rgba(0,0,0,1)",
            } },
            React.createElement("div", { style: { display: "flex" } },
                React.createElement("span", { style: { position: "absolute", left: 0 } },
                    React.createElement(NavBarPanelButton, { text: "Voice", panel: "voice", corner: "top-left" })),
                React.createElement("div", { style: E({ position: "absolute", zIndex: 11, left: 0, top: 45 }, topLeftOpenPanel != "voice" && { boxShadow: colors.navBarBoxShadow, clipPath: "inset(0 -150px -150px 0)", display: "table" }) },
                    topLeftOpenPanel == "stream" && React.createElement(StreamPanel, null),
                    topLeftOpenPanel == "chat" && React.createElement(ChatPanel, null),
                    topLeftOpenPanel == "reputation" && React.createElement(ReputationPanel, null),
                    topLeftOpenPanel == "voice" && React.createElement(VoicePanel, null)),
                React.createElement(Div, { ct: true, style: { position: "fixed", left: 0, width: "30%", top: 45, bottom: 0 } },
                    React.createElement(NotificationsUI, null)),
                React.createElement("span", { style: { margin: "0 auto", paddingRight: 162 } },
                    React.createElement(NavBarPageButton, { page: "users", text: "Members" }),
                    React.createElement(NavBarPageButton, { page: "feedback", text: "Feedback" }),
                    React.createElement(NavBarPageButton, { page: "more", text: "More" }),
                    React.createElement(NavBarPageButton, { page: "home", text: "Story Architect", style: { margin: "0 auto", textAlign: "center", fontSize: 23 } }),
                    React.createElement(NavBarPageButton, { page: "write", text: "Write" })),
                React.createElement("span", { style: { position: "absolute", right: 0, display: "flex" } },
                    React.createElement(RecentActionsSection, null),
                    React.createElement(NavBarPanelButton, { text: IsAuthValid(auth) ? auth.displayName.match(/(.+?)( |$)/)[1] : "Sign in", panel: "profile", corner: "top-right" })),
                React.createElement("div", { style: { position: "absolute", zIndex: 11, right: 0, top: 45,
                        boxShadow: colors.navBarBoxShadow, clipPath: "inset(0 0 -150px -150px)", display: "table" } },
                    topRightOpenPanel == "search" && React.createElement(SearchPanel, null),
                    topRightOpenPanel == "guide" && React.createElement(GuidePanel, null),
                    topRightOpenPanel == "profile" && React.createElement(UserPanel, null)))));
    }
};
NavBar = __decorate([
    Observer
], NavBar);
export { NavBar };
let NavBarPageButton = class NavBarPageButton extends BaseComponentPlus({}, { hovered: false }) {
    render() {
        let { page, text, panel, active, style, onClick } = this.props;
        // let {_radiumStyleState: {main: radiumState = {}} = {}} = this.state as any;
        // let {_radiumStyleState} = this.state as any;
        const { hovered } = this.state;
        const currentPage = store.main.page;
        active = active != null ? active : page == currentPage;
        const finalStyle = E({
            position: "relative", display: "inline-block", cursor: "pointer", verticalAlign: "middle",
            lineHeight: "45px", color: "#FFF", padding: "0 15px", fontSize: 12, textDecoration: "none", opacity: 0.9,
        }, style);
        const actionFunc = (s) => {
            if (page && !panel) {
                if (page != currentPage) {
                    s.main.page = page;
                }
                else {
                    // go to the page root-contents, if clicking on page in nav-bar we're already on
                    //s.main[currentPage].subpage = null;
                    s.main[currentPage].subpage = rootPageDefaultChilds[currentPage];
                    /*if (page == "database") {
                        // if our default subpage is already active, then perform that subpage's action-if-already-active
                        if ([null, "users"].Contains(store.main.database.subpage)) {
                            s.main.database.selectedUserID = null;
                        }
                    } else if (page == "feedback") {
                        s.feedback.main.proposals.selectedProposalID = null;
                    } else if (page == "private") {
                        s.main.private.selectedMapID = null;
                    } else if (page == "public") {
                        s.main.public.selectedMapID = null;
                    }*/
                }
            }
        };
        const hoverOrActive = hovered || active;
        return (React.createElement(Link, { actionFunc: actionFunc, className: "notFocusTarget", style: finalStyle, onMouseEnter: useCallback(() => this.SetState({ hovered: true }), []), onMouseLeave: useCallback(() => this.SetState({ hovered: false }), []), onClick: onClick },
            text,
            hoverOrActive &&
                React.createElement("div", { style: { position: "absolute", left: 0, right: 0, bottom: 0, height: 2, background: "rgba(100,255,100,1)" } })));
    }
};
NavBarPageButton = __decorate([
    Observer
], NavBarPageButton);
export { NavBarPageButton };
let NavBarPanelButton = class NavBarPanelButton extends BaseComponentPlus({}, {}, { active: false }) {
    constructor() {
        super(...arguments);
        this.OnClick = (e) => {
            e.preventDefault();
            const { corner, panel, active } = this.PropsStateStash;
            runInAction("NavBarPanelButton_OnClick", () => {
                if (corner == "top-left") {
                    store.main.topLeftOpenPanel = active ? null : panel;
                }
                else {
                    store.main.topRightOpenPanel = active ? null : panel;
                }
            });
        };
    }
    render() {
        const { text, panel, corner } = this.props;
        const { topLeftOpenPanel, topRightOpenPanel } = store.main;
        const active = (corner == "top-left" ? topLeftOpenPanel : topRightOpenPanel) == panel;
        this.Stash({ active });
        return (React.createElement(NavBarPageButton, { page: panel, text: text, panel: true, active: active, onClick: this.OnClick }));
    }
};
NavBarPanelButton = __decorate([
    Observer
], NavBarPanelButton);
export { NavBarPanelButton };
let RecentActionsSection = class RecentActionsSection extends BaseComponentPlus({}, {}) {
    render() {
        const undoAction = GetUndoAction(MeID());
        const redoAction = GetRedoAction(MeID());
        return (React.createElement(Row, null,
            React.createElement(Button, { text: "<", enabled: undoAction != null, className: "notFocusTarget", title: `Undo: ${undoAction ? undoAction.title || "generic action" : "n/a"}`, onClick: () => {
                    new UndoAction({ id: undoAction._id }).Run();
                } }),
            React.createElement(Button, { text: ">", enabled: redoAction != null, className: "notFocusTarget", title: `Redo: ${redoAction ? redoAction.title || "generic action" : "n/a"}`, onClick: () => {
                    new RedoAction({ id: redoAction._id }).Run();
                } })));
    }
};
RecentActionsSection = __decorate([
    Observer
], RecentActionsSection);
